module.exports = __webpack_public_path__ + "img/zhuoqi.4787fce7.png";